import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input, OnChanges,
	OnInit,
	Output, SimpleChanges,
} from '@angular/core';
import {SelectOption} from "../../interfaces";

@Component({
	selector: 'app-select',
	templateUrl: './select.component.html',
	styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit, OnChanges {
	@Input() label: any;
	@Input() values: SelectOption[];
	@Input() selectedValue: any;
	@Input() style: 'none' | 'white' = 'none';
	@Input() className: string;
	@Input() contentHeight = 46;
	@Input() contentWidth = 200;

	@Output()
	onValueChange = new EventEmitter<string>();


	showOptions = false;

	minContentHeight = 30;
	minContentWidth = 10;

	constructor(private eRef: ElementRef) {
	}

	get classes() {
		return this.style === 'none' ? '' : 'white';
	}

	@HostListener('document:click', ['$event'])
	documentClick(event: MouseEvent) {
		if (!this.eRef.nativeElement.contains(event.target)) {
			this.showOptions = false;
		}
	}

	ngOnInit(): void {
		/*if (!this.label && !!this.values) {
			this.label = this.values[0].label;
		}*/

		this.option = this.selectedValue;

		if (this.contentHeight < this.minContentHeight) {
			this.contentHeight = this.minContentHeight;
		}

		if (this.contentWidth < this.minContentWidth) {
			this.contentWidth = this.minContentWidth;
		}
	}

	onToggle() {
		this.showOptions = !this.showOptions;
	}

	onValueSelection(obj) {
		event?.stopPropagation();
		this.label = obj.label;
		this.onValueChange.emit(obj.value);
		this.showOptions = false;
	}

	private set option(value: any) {
		if (!value) {
			value = '';
		}

		if (this.values) {
			const [obj] = this.values.filter(item => item.value == value);

			this.label = obj.label;
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.selectedValue) {
			this.option = changes.selectedValue.currentValue;
		}
	}
}
